import { css } from 'lit';

export default css`
  :host {
    display: block;
    font-family: var(--font-family-base, 'Inter, Arial, sans-serif');
    --crumb-height: 60px;
    --item-height: 40px;
    --item-bg: transparent;
    --item-bg-hover: var(--surface-raised, var(--color-white, #ffffff));
    --item-border-radius: var(--radius-md, 12px);
    --icon-size: 1rem;
    --text-color: var(--on-surface-muted, var(--color-gray-3, #d7d4d2));
    --text-color-hover: var(--color-secondary-light-1, #c3d6e3);
    --text-color-focus: var(--color-primary-dark, #001d68);
    --text-color-selected: var(--color-secondary, #2594e3);
    --text-color-disabled: var(--color-gray-3, #d7d4d2);
    --icon-color: var(--color-gray-3, #d7d4d2);
    --icon-color-hover: var(--color-secondary-light-1, #c3d6e3);
    --icon-color-focus: var(--color-black, #000000);
    --icon-color-selected: var(--color-secondary, #2594e3);
    --icon-color-disabled: var(--color-gray-3, #d7d4d2);
    --separator-color: var(--color-gray-5, #9ea2ae);
  }

  .breadcrumbs {
    display: flex;
    align-items: center;
    padding: 0;
  }

  .crumb {
    display: flex;
    align-items: center;
    height: var(--crumb-height);
  }

  .item {
    display: flex;
    align-items: center;
    padding: var(--spacing-sm, 12px) var(--spacing-xs, 8px);
    height: var(--item-height);
    border-radius: var(--item-border-radius);
    background: var(--item-bg);
    border: none;
    cursor: pointer;
    max-width: 160px;
    white-space: nowrap;
    transition: background 0.2s ease-in-out, color 0.2s ease-in-out;
  }

  .item:focus-visible {
    outline: 2px solid var(--color-secondary, #2594e3);
    outline-offset: 2px;
  }

  .item[disabled] {
    cursor: not-allowed;
  }

  .icon, ::slotted([slot^="icon-"]) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--icon-size);
    height: var(--icon-size);
    flex: none;
    color: var(--icon-color);
  }

  .separator, ::slotted([slot^="separator-"]) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: var(--icon-size);
    height: var(--icon-size);
    flex: none;
    color: var(--separator-color);
  }

  .text, ::slotted([slot^="text-"]) {
    padding: 0 var(--spacing-xs, 8px);
    font-size: var(--font-size-button-medium, 14px);
    line-height: var(--line-height-button-medium, 16px);
    font-weight: var(--font-weight-semibold, 600);
    text-align: center;
    text-overflow: ellipsis;
    color: var(--text-color);
  }

  .item[data-state="default"] .icon,
  .item[data-state="default"] ::slotted([slot^="icon-"]) {
    color: var(--icon-color);
  }

  .item[data-state="default"] .text,
  .item[data-state="default"] ::slotted([slot^="text-"]) {
    color: var(--text-color);
  }

  .item[data-state="hover"] {
    background: var(--item-bg-hover);
  }

  .item[data-state="hover"] .icon,
  .item[data-state="hover"] ::slotted([slot^="icon-"]) {
    color: var(--icon-color-hover);
  }

  .item[data-state="hover"] .text,
  .item[data-state="hover"] ::slotted([slot^="text-"]) {
    color: var(--text-color-hover);
  }

  .item[data-state="focus"] {
    background: var(--item-bg-hover);
  }

  .item[data-state="focus"] .icon,
  .item[data-state="focus"] ::slotted([slot^="icon-"]) {
    color: var(--icon-color-focus);
  }

  .item[data-state="focus"] .text,
  .item[data-state="focus"] ::slotted([slot^="text-"]) {
    color: var(--text-color-focus);
  }

  .item[data-state="selected"] .icon,
  .item[data-state="selected"] ::slotted([slot^="icon-"]) {
    color: var(--icon-color-selected);
  }

  .item[data-state="selected"] .text,
  .item[data-state="selected"] ::slotted([slot^="text-"]) {
    color: var(--text-color-selected);
  }

  .item[data-state="disabled"] .icon,
  .item[data-state="disabled"] ::slotted([slot^="icon-"]) {
    color: var(--icon-color-disabled);
  }

  .item[data-state="disabled"] .text,
  .item[data-state="disabled"] ::slotted([slot^="text-"]) {
    color: var(--text-color-disabled);
  }

  @media (max-width: 768px) {
    .breadcrumbs {
      flex-wrap: wrap;
    }
    .crumb {
      height: auto;
      margin-bottom: var(--spacing-xs, 8px);
    }
    .item {
      max-width: 120px;
      padding: var(--spacing-xs, 8px);
      height: 32px;
    }
    .text, ::slotted([slot^="text-"]) {
      font-size: var(--font-size-b3, 12px);
    }
  }
`;